var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvertissement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32.8 29",
    style: {
      enableBackground: "new 0 0 32.8 29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M32.4,26.4L17.9,1.2c-0.3-0.5-0.8-0.8-1.4-0.8c-0.6,0-1.1,0.3-1.4,0.8L0.5,26.4c-0.3,0.5-0.3,1.1,0,1.6 c0.3,0.5,0.8,0.8,1.4,0.8H31c0.6,0,1.1-0.3,1.4-0.8C32.7,27.5,32.7,26.9,32.4,26.4z M17.9,25.6c-0.4,0.4-0.9,0.6-1.5,0.6 c-0.6,0-1.1-0.2-1.5-0.6c-0.4-0.4-0.7-0.9-0.7-1.6c0-0.6,0.2-1.1,0.6-1.5c0.8-0.8,2.2-0.8,3.1,0c0.4,0.4,0.6,0.9,0.6,1.5 C18.5,24.6,18.3,25.2,17.9,25.6z M18.4,13.4l-0.5,4c-0.1,0.7-0.2,1.2-0.4,1.6c-0.3,0.5-0.7,0.8-1.3,0.8c-0.6,0-1.1-0.3-1.3-0.8 c-0.2-0.4-0.3-0.9-0.4-1.7l0,0l-0.3-3.9c-0.1-1-0.1-1.7-0.1-2.2c0-0.7,0.2-1.3,0.6-1.8c0.4-0.4,1-0.7,1.6-0.7c1,0,1.5,0.5,1.7,0.9 c0.2,0.5,0.4,1.2,0.4,2.1C18.5,12.4,18.5,12.9,18.4,13.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvertissement);
export default __webpack_public_path__ + "static/media/Avertissement.2cb560a5.svg";
export { ForwardRef as ReactComponent };